/**
 * **Las claves de la caché, en un solo sitio.**
 *
 * Las usan todos los temas de la carpeta, y varios invalidan las de otro —cambiar un salario
 * invalida la estructura de costos—, así que no pueden vivir dentro de un tema: el primero que las
 * tuviera se volvería el dueño de la caché de los demás. Repetir el literal en dos archivos es peor
 * todavía: dos claves que se escriben parecido y no son la misma dejan media pantalla con cifras
 * viejas, y eso no se nota hasta que alguien compara dos totales.
 */

export const keys = {
  families: ["product-families"] as const,
  categories: ["materials", "categories"] as const,
  materials: ["materials"] as const,
  prices: (id: string) => ["materials", id, "prices"] as const,
  payroll: ["payroll"] as const,
  // Cuelga de `payroll`: cambiar un parámetro invalida también la escalera.
  salaryReference: ["payroll", "reference"] as const,
  // También cuelga de `payroll`: cambiar una tarifa cambia lo que vale una hora extra.
  payrollRates: ["payroll", "rates"] as const,
  employees: ["employees"] as const,
  labor: ["labor-summary"] as const,
  expenses: ["overhead", "expenses"] as const,
  obligations: ["overhead", "obligations"] as const,
  overhead: ["overhead", "summary"] as const,
  structure: ["costs", "structure"] as const,
  // El formato entra en la clave: dos formatos son dos costos distintos, no uno que cambia.
  baseCost: (formatId?: string, line = "tile") => ["costs", "base", formatId ?? "por-defecto", line] as const,
  // Cuelga de `["costs", "base"]`: guardar una receta la vuelve a pedir junto con el costo.
  baseMix: (formatId: string) => ["costs", "base", "mix", formatId] as const,
  schedule: ["schedule"] as const,
};
